import { render, staticRenderFns } from "./ShiftSetup.vue?vue&type=template&id=53bd691d&scoped=true&"
import script from "./ShiftSetup.vue?vue&type=script&lang=js&"
export * from "./ShiftSetup.vue?vue&type=script&lang=js&"
import style0 from "./ShiftSetup.vue?vue&type=style&index=0&id=53bd691d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd691d",
  null
  
)

export default component.exports